import { alpha, styled } from "@mui/material/styles";
import { DataGridPro, gridClasses } from "@mui/x-data-grid-pro";
import {
	dataGridCellClassNames,
	dataGridRowClassNames,
} from "src/components/common/dataGrid/styles/dataGridClassNames.ts";

const ODD_OPACITY = 0.08;

export const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
	[`& .${gridClasses.columnHeaders}`]: {
		backgroundColor: "rgba(192,192,192, 0.1)",
		borderBottom: `1px solid ${theme.palette.grey[600]}`,
	},
	[`& .${gridClasses.footerContainer}`]: {
		minHeight: "2.0rem",
		height: "2.0rem",
	},
	[`& .${gridClasses.row}`]: {
		"&:hover, &.Mui-hovered": {
			backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
			"@media (hover: none)": {
				backgroundColor: "transparent",
			},
		},
		"&.Mui-selected": {
			backgroundColor: alpha(
				theme.palette.primary.main,
				ODD_OPACITY + theme.palette.action.selectedOpacity,
			),
			"&:hover, &.Mui-hovered": {
				backgroundColor: alpha(
					theme.palette.primary.main,
					ODD_OPACITY +
						theme.palette.action.selectedOpacity +
						theme.palette.action.hoverOpacity,
				),
				// Reset on touch devices, it doesn't add specificity
				"@media (hover: none)": {
					backgroundColor: alpha(
						theme.palette.primary.main,
						ODD_OPACITY + theme.palette.action.selectedOpacity,
					),
				},
			},
		},
	},
	[`& .${dataGridRowClassNames.even}`]: {
		backgroundColor: theme.palette.common.white,
	},
	[`& .${dataGridRowClassNames.odd}`]: {
		backgroundColor: theme.palette.grey[100],
	},
	[`& .${dataGridRowClassNames.edited}`]: {
		backgroundColor: "rgba(255,255,0, .15)",
	},
	[`& .${dataGridRowClassNames.unsavedNew}`]: {
		backgroundColor: "rgba(0,128,0, .15)",
	},
	[`& .${dataGridRowClassNames.green}`]: {
		backgroundColor: "rgba(0,255,0,0.25)",
	},
	[`& .${dataGridRowClassNames.yellow}`]: {
		backgroundColor: "rgba(255,255,0, .25)",
	},

	[`& .${dataGridCellClassNames.invalid}`]: {
		border: `2px solid ${theme.palette.error.main}`,
	},
	[`& .${dataGridCellClassNames.warning}`]: {
		backgroundColor: theme.palette.warning.main,
		color: theme.palette.warning.contrastText,
	},
})) as typeof DataGridPro;
